import { render, staticRenderFns } from "./MySetting.vue?vue&type=template&id=a1b14ede&scoped=true&"
import script from "./MySetting.vue?vue&type=script&lang=js&"
export * from "./MySetting.vue?vue&type=script&lang=js&"
import style0 from "./MySetting.vue?vue&type=style&index=0&id=a1b14ede&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b14ede",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1b14ede')) {
      api.createRecord('a1b14ede', component.options)
    } else {
      api.reload('a1b14ede', component.options)
    }
    module.hot.accept("./MySetting.vue?vue&type=template&id=a1b14ede&scoped=true&", function () {
      api.rerender('a1b14ede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Camstudy/control/MySetting.vue"
export default component.exports